import { TProjectConfigurationParameter } from 'entries/common/widgets/project-configuration/context';

type TFacet = {
  id: string;
  values: string[];
};

export const dispatchProjectUpdatedCustomEvent = ({
  projectUpdatedCustomEventName,
  projectUpdatedCustomEventPayload,
}: {
  projectUpdatedCustomEventName: string;
  projectUpdatedCustomEventPayload: {
    projectConfigurationParameters: Array<TProjectConfigurationParameter>;
    facets?: TFacet[];
  };
}) => {
  document.body.dispatchEvent(
    new CustomEvent(projectUpdatedCustomEventName, {
      cancelable: true,
      bubbles: true,
      composed: true,
      detail: projectUpdatedCustomEventPayload,
    })
  );
};
